import React, { useState, useEffect } from 'react';
import ChatBox from './ChatBox';
import Card from 'react-bootstrap/Card';

const Chat = () => {
    const [chatOpen, setChatOpen] = useState(true);
    const [contextMessage, setContextMessage] = useState(null);

    useEffect(() => {
        // Check for context injected by backend
        if (window.CHAT_CONTEXT) {
            console.log("Context received:", window.CHAT_CONTEXT);
            setContextMessage(window.CHAT_CONTEXT);
            // Optional: Clear it so it doesn't persist on navigation if we don't want it to
            // window.CHAT_CONTEXT = null; 
        }
    }, []);

    return (
        <div className="container">
            <h1 className="cover-heading">Chat Assistant</h1>
            <Card className="theme-card">
                <Card.Body>
                    <p>Ask for music recommendations and playlist building help</p>
                    {/* We force chatOpen to true and maybe hide the toggle if we want it always open, 
              but reusing ChatBox as is is safer for now. */}
                    <ChatBox
                        isOpen={chatOpen}
                        onToggle={() => setChatOpen(!chatOpen)}
                        initialContext={contextMessage}
                    />
                </Card.Body>
            </Card>
            <br />
        </div>
    );
};

export default Chat;
